<template>
  <div>
    <!-- Title -->
    <div class="content">
      <h2 class="subtitle">Pregled ruta teretnih vozila - mjesečni</h2>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi mjesec</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content">
      <date-picker
        v-model="time3"
        @input="monthChosen"
        type="month"
      ></date-picker>
    </div>

    <!-- Table -->
    <div class="base-demo">
      <vue-table-dynamic
        class="small"
        :params="params"
        ref="table"
        @cell-click="tableCellClicked"
        @cell-change="onCellChange"
      ></vue-table-dynamic>
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import ReportService from "../../services/report.service";
import VueTableDynamic from "vue-table-dynamic";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { maskIfEquealsValue } from "../../_helpers/arrangers";

export default {
  name: "RouteReportMonth",
  components: {
    VueTableDynamic,
    DatePicker,
  },
  data() {
    return {
      //   monthChosen
      time3: null,
      firstDay: null,
      lastDay: null,
      selectedMonth: 0,
      selectedYear: 0,
      employees: [],
      freightVehicles: [],
      rawData: [],
      params: {
        data: [
          [
            "Ndx",
            "Ime i prezime",
            "Vozilo",
            "Broj tura",
            "Pređeno km",
            "BD-TV",
            "KO-HN",
            "PE-UL",
            "NK",
            "Sjever",
            "Lokal",
            "Ispor. dr. vozača",
            "Druga tura",
            "Titex",
            "Povrat",
            "Ostala zapažanja",
          ],
        ],
        header: "row",
        enableSearch: true,
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: "3%" },
          { column: 1, width: "12%" },
          { column: 2, width: "10%" },
          { column: 15, width: "12%" },
        ],
        edit: {
          column: [-1, -2],
        },
      },
      departments: [],
      seletedDepartment: null,
    };
  },
  mounted() {
    this.time3 = new Date();
    this.monthChosen(this.time3);
    this.getDepartments();
  },
  methods: {
    tableCellClicked() {},
    resetUi() {
      this.params.data = [
        [
          "Ndx",
          "Ime i prezime",
          "Vozilo",
          "Broj tura",
          "Pređeno km",
          "BD-TV",
          "KO-HN",
          "PE-UL",
          "NK",
          "Sjever",
          "Lokal",
          "Ispor. dr. vozača",
          "Druga tura",
          "Titex",
          "Povrat",
          "Ostala zapažanja",
        ],
      ];
      this.dailyLogs = [];
      this.rawData = [];
      this.employeeIdsBeenOnRoute = [];
    },
    monthChosen(mnth) {
      // console.log(mnth);
      this.selectedMonth = mnth.getMonth() + 1;
      this.selectedYear = mnth.getFullYear();
      // console.log(this.selectedMonth);
      // console.log(this.selectedYear);
      this.firstDay = new Date(mnth.getFullYear(), mnth.getMonth(), 1);
      this.lastDay = new Date(mnth.getFullYear(), mnth.getMonth() + 1, 0);
      // console.log(this.firstName);
      // console.log(this.lastDay);
    },
    getDepartments() {
      UserService.getDepartments().then((response) => {
        // reset ui
        this.departmentData = response.data;
        this.arrangeSectors(response.data);
        this.arrangeEmployees(response.data);

        // now get freight vehicles
        ReportService.GetFreightVehicles().then((fv) => {
          this.freightVehicles = fv.data;
          this.freightVehicles.forEach((fv) => {
            // console.log(this.employees);
            // console.log(fv.employeeId);
            // console.log(this.employees.find((e) => e.id === fv.employeeId));
            this.rawData.push([
              fv.vehicleId,
              this.employees.find((e) => e.id === fv.employeeId) != null
                ? this.employees.find((e) => e.id === fv.employeeId).name
                : "zajedničko vozilo",
              fv.model,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              "",
            ]);
          });
          // load data
          ReportService.GetFreightOutsideEventsByDate(
            this.firstDay,
            this.lastDay
          ).then((response) => {
            // console.log("data");
            // console.log(response.data);
            this.pushData(response.data);
          });
        });
      });
    },
    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },
    arrangeEmployees(data) {
      data.forEach((element) => {
        element.employee.forEach((emp) => {
          this.employees.push({
            name: emp.firstName + " " + emp.lastName,
            id: emp.employeeId,
          });
        });
      });
    },
    onCellChange(rowIndex, columnIndex, data) {
      console.log("onCellChange: ", rowIndex, columnIndex, data);
      console.log("table data: ", this.$refs.table.getData());
    },

    calculateSecondRoutes(data) {
      let employeeOnRoute = [];
      data.forEach((element) => {
        if (element.isLogicallyColosed) {
          let id = element.employeeId;
          let name = element.name;
          let date = element.departureTime.split("T")[0];

          // does already exist?
          let result = employeeOnRoute.find((x) => {
            return x.id === id && x.date === date;
          });

          // do not exists
          if (typeof result === "undefined") {
            employeeOnRoute.push({
              id: id,
              name: name,
              date: date,
              occurance: 1,
            });
          } else {
            let index = employeeOnRoute.indexOf(result);
            // console.log("mačak");
            employeeOnRoute[index].occurance++;
            // console.log(employeeOnRoute[index]);
          }
        }
      });
      return employeeOnRoute;
    },

    pushData(data) {
      data.forEach((oe) => {
        if (oe.isLogicallyColosed === true) {
          let correspondingRow = this.rawData.find(
            (d) => d[0] === oe.vehicleId
          );

          correspondingRow[3]++;

          correspondingRow[4] += oe.lengthKilometer / 1000;

          switch (oe.routeDescription) {
            case "BD-TV":
              correspondingRow[5]++;
              break;
            case "KO-HN":
              correspondingRow[6]++;
              break;
            case "PE-UL":
              correspondingRow[7]++;
              break;
            case "NK":
              correspondingRow[8]++;
              break;
            case "Sjever":
              correspondingRow[9]++;
              break;
            case "Lokal":
              correspondingRow[10]++;
              break;
            case "Titex":
              correspondingRow[13]++;
              break;
          }
        }
      });

      // calulate second route
      this.employeeIdsBeenOnRoute = this.calculateSecondRoutes(data);
      // console.log(this.employeeIdsBeenOnRoute);
      // console.log(this.rawData);

      this.employeeIdsBeenOnRoute.forEach((element) => {
        // console.log(element);
        let correspondingRow = this.rawData.find((d) => d[1] === element.name);
        if (element.occurance > 1) {
          correspondingRow[12]++;
        }
      });

      // data loaded, push
      this.rawData.forEach((element) => {
        this.params.data.push([
          element[0],
          element[1],
          element[2],
          maskIfEquealsValue(element[3], "0"),
          maskIfEquealsValue(element[4].toFixed(2), "0.00"),
          maskIfEquealsValue(element[5], "0"),
          maskIfEquealsValue(element[6], "0"),
          maskIfEquealsValue(element[7], "0"),
          maskIfEquealsValue(element[8], "0"),
          maskIfEquealsValue(element[9], "0"),
          maskIfEquealsValue(element[10], "0"),
          maskIfEquealsValue(element[11], "0"),
          maskIfEquealsValue(element[12], "0"),
          maskIfEquealsValue(element[13], "0"),
          maskIfEquealsValue(element[14], "0"),
          element[15],
        ]);
      });
    },
  },
};
</script>

<style scoped>
.small {
  font-size: 11px;
}
</style>
